import React,{useState,useEffect,useRef}from 'react'
import { Modal,Form,Input, App} from 'antd';
import {  useChanpinTypeUpdateSaveMutation } from '../../../store/DianShangYeWuApi';  
function GoodsEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        // console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        dscp_name:props.dscp_name,
        dscp_qy_id:props.qy_id,
        dscp_qy_name:props.qy_name,
        dscp_uid:props.yh_id,
        dscp_uname:props.yh_name,
        dscp_id:props.dscp_id,
        dscp_update_uname:props.yh_name,
    }); 
    const editForm = useRef()
    useEffect(() => {
        if(editForm.current){   
            editForm.current.setFieldsValue({
                dscp_name:props.dscp_name,
            })   
        }
    },[open ,props.dscp_name])
    const [goodsEdit] = useChanpinTypeUpdateSaveMutation()    
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.dscp_name}</a>
            <Modal
                open={open}
                title='修改产品'
                okText="保存"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {                    
                    form
                        .validateFields()
                        .then((values) => {
                            goodsEdit(info).then((res) => {
                                // console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('修改成功')   
                                    setOpen(false);
                                    form.resetFields();
                                    onCreateEdit(values);
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('修改失败：'+res.data.Message)
                                }
                            })
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_client_edit_${props.yh_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 5 }}
                    ref={editForm}
                >                    
                    <Form.Item name="dscp_name" wrapperCol={{span:19}} required label='产品名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,dscp_name:e.target.value}))
                        }}/>
                    </Form.Item>                                           
                </Form>
            </Modal>
        </>
    )
}

export default GoodsEdit